import React  from "react";
import { Button } from "reactstrap";

const GoogleButton = ({color})=> {

  const googleAuth = ()=> {
    const queryParams   = new URLSearchParams({
      client_id              : process.env.REACT_APP_LOGIN_WITH_GOOGLE_ID,
      redirect_uri           : `${window.location.origin}/google-oauth2-callback/`,
      response_type          : "code",
      access_type            : "offline",
      include_granted_scopes : "true",
      state                  : "98765432",
      scope                  : "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile",
    });

    window.location = `https://accounts.google.com/o/oauth2/v2/auth?${queryParams.toString()}`;
  };

  return (
    <Button color={color} className='btn-lg' onClick={googleAuth}>
      <i className="fa fa-google"></i>
      <span className="m-l-10"> Google </span>
    </Button>
  );
};

export default GoogleButton;
